module.exports = __webpack_public_path__ + "static/media/chocolateFrosting.401733c0.jpg";